import React from 'react'

import { useAnalysisType } from 'redux/hooks/AnalysisTypes'
import { useTranslation } from 'language/translator'

import ContentBox from 'components_new/molecules/ContentBox'
import RichTextEditor from 'components_new/molecules/RichTextEditor'
import { toEditorValue } from 'components_new/molecules/RichTextEditor/contract'

interface AnalysisTypeNoiImpactProps {
  id: string
}

/**
 * How the analysis type moves driftnettot, as the product team wrote it.
 * Renders nothing while the field is empty.
 */
const AnalysisTypeNoiImpact = (props: AnalysisTypeNoiImpactProps) => {
  const { id } = props

  const { analysisType } = useAnalysisType(id)
  const { t } = useTranslation()

  if (!analysisType?.noi_impact) return null

  return (
    <ContentBox
      border={true}
      collapse={{
        active: true,
        defaultCollapsed: false
      }}
      header={{
        color: 'secondary',
        divider: true,
        title: t('analysis_types', 'field_noi_impact')
      }}
      sx={{ mb: 2 }}
    >
      <RichTextEditor
        edit={false}
        noGutter={true}
        paragraphVariant="body1"
        value={toEditorValue(analysisType.noi_impact)}
      />
    </ContentBox>
  )
}

export default AnalysisTypeNoiImpact
